module.exports = __webpack_public_path__ + "static/media/digital_card_back.4218865a.png";